import { getAppMarketUrl } from './app-marker-url.js';
import { getRedirectServiceUrl } from './redirect-service-url.js';
import type { PlatformsType } from './redirect-service-url.js';

export function getAppPreviewUrl({
  appId,
  versionOverrideId,
  platform,
}: {
  platform: PlatformsType;
  appId: string;
  versionOverrideId: string;
}) {
  /**
   * `appId` and `siteId` are omitted — app market will append them to
   * `postInstallationUrl` once the user selects a site during installation
   */
  const redirectUrl = getRedirectServiceUrl({
    platform,
    versionOverrideId,
  });

  return getAppMarketUrl({
    appId,
    versionOverrideId,
    postInstallationUrl: redirectUrl,
  });
}
